import { render, staticRenderFns } from "./loginForm.vue?vue&type=template&id=0b3bce56&scoped=true&"
import script from "./loginForm.vue?vue&type=script&lang=js&"
export * from "./loginForm.vue?vue&type=script&lang=js&"
import style0 from "@/styles/super.css?vue&type=style&index=0&id=0b3bce56&prod&scoped=true&lang=css&"
import style1 from "./loginForm.vue?vue&type=style&index=1&id=0b3bce56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3bce56",
  null
  
)

export default component.exports